import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Markup } from 'interweave'

import { message } from 'antd'

import AccessLevelUmkd from './accessLevelUmkd'
import { AppStateType } from '../../../../../bll/store'
import errorHandler from '../../../../../bll/errorHandler'
import openNotification from '../../../../_ui/notification'
import { addAccessLevelUmkd, clearDictDirectionTraining, clearDictEducationalProgram, clearLevelUmkd, deleteAccessLevelUmkd, editDictDirectionTraining, editDictEducationalProgram, getDictDirectionTraining, getDictEducationalProgram, getLevelUmkd } from '../../../../../bll/settings/settingOperations'

const AccessLevelUmkdContainer = (props: any) => {
    const [checkedAllCount, setCheckedAllCount] = React.useState(0) // Выбранные специализации
    
    const [isVisibleLoaderLevelsOperator, setIsVisibleLoaderLevelsOperator] = React.useState(false) // Видимость загрузчика при загрузке уровней доступа оператора
    const [isVisibleLoaderDirectionTraining, setIsVisibleLoaderDirectionTraining] = React.useState(false) // Видимость загрузчика при загрузке справочника направлений подготовки
    const [isVisibleLoaderSpecialization, setIsVisibleLoaderSpecialization] = React.useState(false) // Видимость загрузчика при загрузке справочника специализаций
    
    const [getFilterDirectionTraining, setFilterDirectionTraining] = React.useState('') // Фильтр направлений подготовки
    const [getFilterEducationalProgram, setFilterEducationalProgram] = React.useState('') // Фильтр образовательных программ

    React.useEffect(() => {
        setIsVisibleLoaderLevelsOperator(true)
        setIsVisibleLoaderDirectionTraining(true)

        props.getLevelUmkd(props.selectedOperatorID).then((result: any) => {
            setIsVisibleLoaderLevelsOperator(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Список уровней доступа...", props.msg.err_0027, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        props.getDictDirectionTraining().then((result: any) => {
            setIsVisibleLoaderDirectionTraining(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Список направлений подготовки...", props.msg.err_0028, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        return () => {
            props.clearLevelUmkd()
            props.clearDictDirectionTraining()
            props.clearDictEducationalProgram()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    // Выбор направления подготовки в списке
    const onClickDirectionTraining = (trainingID: number) => {
        setIsVisibleLoaderSpecialization(true)
        const currentList = [...props.dictDirectionTrainingList]

        currentList.forEach(training => {
            if (training.id === trainingID) {
                training.isSelected = true
            } else {
                training.isSelected = false
            }
        })

        props.editDictDirectionTraining(currentList) // Обновляем список направлений подготовки
        
        // Загружаем справочник образовательных программ
        props.getDictEducationalProgram(trainingID).then((result: any) => {
            setIsVisibleLoaderSpecialization(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Список специализаций...", props.msg.err_0029, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })
    }

    // Выбор образовательных программ
    const onChangeSpecialization = (specializationID: any, isChecked: boolean) => {
        const currentList = [...props.dictEducationalProgramList]

        currentList.forEach(i => {
            if (i.id === specializationID) {
                i.isSelected = isChecked

                if (isChecked) {
                    setCheckedAllCount(checkedAllCount + 1) 
                }
                else { setCheckedAllCount(checkedAllCount - 1) }
            }
        })

        props.editDictEducationalProgram(currentList) // Обновляем список образовательных программ
    }

    // Функция по выбору всех специализаций
    const onChangeSelectedAllSpecialization = (isChecked: boolean) => {
        const currentList = [...props.dictEducationalProgramList]

        currentList.forEach(i => {
            i.isSelected = isChecked
        })

        if (isChecked) {
            setCheckedAllCount(currentList.length)
        } else { setCheckedAllCount(0) }
        
        props.editDictEducationalProgram(currentList) // Обновляем список образовательных программ
    }

    // Очистка полей фильтра
    const clearFilterValues = (fieldType: string) => {
        if (fieldType === "directionTraining") { setFilterDirectionTraining('') }
        if (fieldType === "specialization") { setFilterEducationalProgram('') }
    }

    // Кнопка удалить уровень доступа
    const onClickButtonDelete = (trainingID: number, trainingName: string, specializationID: number, specializationName: string) => {
        props.deleteAccessLevelUmkd(props.selectedOperatorID, trainingID, specializationID).then((result: any) => {
            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Удаление уровня доступа...", props.msg.err_0030, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }

            openNotification(
                "Удалён уровень доступа...", 
                `${trainingID} → ${trainingName}</br>${specializationID} → ${specializationName}`, 
                "success", "bottomRight"
            )
        })
    }

    // Кнопка добавить уровень доступа
    const onClickButtonAdd = () => {
        let errorRule = false, directionTrainingID: number, directionTrainingName: string, educationalPrograms: any

        if (props.dictDirectionTrainingList.filter((item: any) => item.isSelected === true).length === 0) {
            errorRule = true
            openNotification("Направление подготовки...", "Вы не выбрали направление подготовки.", "error", "bottomRight")
        }

        if (props.dictEducationalProgramList.filter((item: any) => item.isSelected === true).length === 0) {
            errorRule = true
            openNotification("Специализации...", "Вы не выбрали специализации.", "error", "bottomRight")
        }

        if (!errorRule) {
            // Получаем выбранный идентификатор и имя направления подготовки
            directionTrainingID = props.dictDirectionTrainingList.filter((item: any) => item.isSelected === true)[0].id
            directionTrainingName = props.dictDirectionTrainingList.filter((item: any) => item.isSelected === true)[0].name

            // Получаем список выбранных образовательных программ
            educationalPrograms = props.dictEducationalProgramList.filter((item: any) => item.isSelected === true)

            

            educationalPrograms.forEach((eduProg: any) => {
                if (props.levelUmkdList.filter((item: any) => item.direction_training_id === directionTrainingID && item.educational_program_id === eduProg.id).length !== 0) {
                    message.error(<Markup content={`<b>УЖЕ ДОБАВЛЕНО</b> → ${directionTrainingName} → ${eduProg.name}.`} />, 10)
                } else {
                    props.addAccessLevelUmkd(props.selectedOperatorID, directionTrainingID, eduProg.id).then((result: any) => {
                        switch (result?.code) {
                            case "ERR_QUERY_STRING": { return openNotification("Добавление уровня доступа...", props.msg.err_0031, "error", "bottomRight") }
                            default: errorHandler(result?.code, props.msg); break
                        }
                    })
                }
            })

            openNotification("Назначение уровней доступа...", "Данные по уровням доступа успешно обновлены.", "success", "bottomRight")
        }
    }



    // Свойства передаваемые к компоненту
    const propsToAccessLevelUmkd = {
        getFilterDirectionTraining, setFilterDirectionTraining, // Фильтр направлений подготовки
        getFilterEducationalProgram, setFilterEducationalProgram, // Фильтр образовательных программ
        clearFilterValues, // Очистка полей фильтра

        isVisibleLoaderLevelsOperator, isVisibleLoaderDirectionTraining, isVisibleLoaderSpecialization, // Видимость загрузчиков

        onClickDirectionTraining, onChangeSpecialization, // Выбор направления подготовки (специализации) в списке
        onChangeSelectedAllSpecialization, // Функция по выбору всех специализаций
        checkedAllCount, // Выбранные специализации

        onClickButtonDelete, // Кнопка удалить уровень доступа
        onClickButtonAdd, // Кнопка добавить уровень доступа
    }   

    return (
        <AccessLevelUmkd {...props} {...propsToAccessLevelUmkd} />
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        levelUmkdList: state.settings.levelUmkdList,
        dictDirectionTrainingList: state.settings.dictDirectionTrainingList,
        dictEducationalProgramList: state.settings.dictEducationalProgramList,
    }
}


export default compose(connect(mapState, { 
    getLevelUmkd, clearLevelUmkd, deleteAccessLevelUmkd, addAccessLevelUmkd,
    getDictDirectionTraining, editDictDirectionTraining, clearDictDirectionTraining,
    getDictEducationalProgram, editDictEducationalProgram, clearDictEducationalProgram,
}))(AccessLevelUmkdContainer)